import React from "react";
import CsvUploader from "../components/CsvUploader";


function UploadCSV() {
  return <CsvUploader />; // Just render the page
}

export default UploadCSV;
